var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c("div", {
          staticClass: "page-header-top-container",
          staticStyle: { display: "none" }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c("div", { staticClass: "col-12" }, [
            _c(
              "div",
              { staticClass: "tab tab2" },
              [
                _c(
                  "div",
                  { staticClass: "cards-right page-name-right datecss" },
                  [
                    _vm.timeToday != ""
                      ? [
                          _vm._v(
                            _vm._s(_vm.date) +
                              " | " +
                              _vm._s(_vm.timeToday) +
                              " " +
                              _vm._s(_vm.ampm)
                          )
                        ]
                      : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "b-tabs",
                  [
                    _c(
                      "b-tab",
                      {
                        attrs: {
                          title: "Open Customer Numbers",
                          active: "",
                          id: "openTickets"
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "grid-container" },
                          [
                            _vm.ticketsAvailableFound == true
                              ? [
                                  _vm._l(_vm.ticketsAvailable, function(
                                    ticket,
                                    key
                                  ) {
                                    return [
                                      ticket.ticket_closed_at == null
                                        ? [
                                            _c(
                                              "div",
                                              {
                                                key: key,
                                                staticClass: "cards-block"
                                              },
                                              [
                                                ticket.is_printed == 0
                                                  ? [
                                                      _c(
                                                        "b-card",
                                                        {
                                                          staticClass:
                                                            "mb-2 custom-card-body ticket-unprinted",
                                                          attrs: {
                                                            tag: "article"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "cards-left"
                                                            },
                                                            [
                                                              _c(
                                                                "p",
                                                                {
                                                                  staticClass:
                                                                    "card-text cards-page-name"
                                                                },
                                                                [
                                                                  _c("strong", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        ticket.ticket_number
                                                                      )
                                                                    )
                                                                  ])
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("timeago", {
                                                                attrs: {
                                                                  datetime:
                                                                    ticket.ticket_generated_date_time,
                                                                  "auto-update": 60,
                                                                  locale:
                                                                    "en-US"
                                                                }
                                                              })
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "form-group cards-right"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "checkbox-inline checkbox-bootstrap checkbox-lg"
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    attrs: {
                                                                      id:
                                                                        ticket.id,
                                                                      type:
                                                                        "checkbox"
                                                                    },
                                                                    on: {
                                                                      change: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.closeTicket(
                                                                          $event,
                                                                          ticket.id,
                                                                          ticket.ticket_number
                                                                        )
                                                                      }
                                                                    }
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _c("span", {
                                                                    staticClass:
                                                                      "checkbox-placeholder"
                                                                  })
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                ticket.is_printed == 1
                                                  ? [
                                                      _c(
                                                        "b-card",
                                                        {
                                                          staticClass:
                                                            "mb-2 custom-card-body",
                                                          attrs: {
                                                            tag: "article"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "cards-left"
                                                            },
                                                            [
                                                              _c(
                                                                "p",
                                                                {
                                                                  staticClass:
                                                                    "card-text cards-page-name"
                                                                },
                                                                [
                                                                  _c("strong", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        ticket.ticket_number
                                                                      )
                                                                    )
                                                                  ])
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("timeago", {
                                                                attrs: {
                                                                  datetime:
                                                                    ticket.ticket_generated_date_time,
                                                                  "auto-update": 60,
                                                                  locale:
                                                                    "en-US"
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              ticket.is_user_comment !=
                                                              0
                                                                ? [
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          ticket.user_comment
                                                                        )
                                                                      )
                                                                    ])
                                                                  ]
                                                                : [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "user-comment-box"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "input",
                                                                          {
                                                                            directives: [
                                                                              {
                                                                                name:
                                                                                  "model",
                                                                                rawName:
                                                                                  "v-model",
                                                                                value:
                                                                                  ticket.user_comment,
                                                                                expression:
                                                                                  "ticket.user_comment"
                                                                              }
                                                                            ],
                                                                            attrs: {
                                                                              id:
                                                                                "comment-textbox-" +
                                                                                ticket.id,
                                                                              type:
                                                                                "text",
                                                                              name:
                                                                                "user_comment",
                                                                              maxlength:
                                                                                _vm.ticketCommentMaxLength
                                                                            },
                                                                            domProps: {
                                                                              value:
                                                                                ticket.user_comment
                                                                            },
                                                                            on: {
                                                                              keyup: function(
                                                                                $event
                                                                              ) {
                                                                                if (
                                                                                  !$event.type.indexOf(
                                                                                    "key"
                                                                                  ) &&
                                                                                  _vm._k(
                                                                                    $event.keyCode,
                                                                                    "enter",
                                                                                    13,
                                                                                    $event.key,
                                                                                    "Enter"
                                                                                  )
                                                                                ) {
                                                                                  return null
                                                                                }
                                                                                return _vm.submitUserComment(
                                                                                  ticket
                                                                                )
                                                                              },
                                                                              input: function(
                                                                                $event
                                                                              ) {
                                                                                if (
                                                                                  $event
                                                                                    .target
                                                                                    .composing
                                                                                ) {
                                                                                  return
                                                                                }
                                                                                _vm.$set(
                                                                                  ticket,
                                                                                  "user_comment",
                                                                                  $event
                                                                                    .target
                                                                                    .value
                                                                                )
                                                                              }
                                                                            }
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "fa fa-arrow-right",
                                                                            attrs: {
                                                                              id:
                                                                                "comment-button-" +
                                                                                ticket.id,
                                                                              "aria-hidden":
                                                                                "true"
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.submitUserComment(
                                                                                  ticket
                                                                                )
                                                                              }
                                                                            }
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "b-tooltip",
                                                                          {
                                                                            staticClass:
                                                                              "comment-tool-tip",
                                                                            attrs: {
                                                                              target:
                                                                                "comment-textbox-" +
                                                                                ticket.id,
                                                                              placement:
                                                                                "bottom"
                                                                            }
                                                                          },
                                                                          [
                                                                            ticket.user_comment !=
                                                                            null
                                                                              ? [
                                                                                  _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticStyle: {
                                                                                        "font-size":
                                                                                          "12px"
                                                                                      }
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          _vm.ticketCommentMaxLength -
                                                                                            ticket
                                                                                              .user_comment
                                                                                              .length
                                                                                        )
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ]
                                                                              : [
                                                                                  _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticStyle: {
                                                                                        "font-size":
                                                                                          "12px"
                                                                                      }
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          _vm.ticketCommentMaxLength
                                                                                        )
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ]
                                                                          ],
                                                                          2
                                                                        )
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "comment-error",
                                                                        attrs: {
                                                                          id:
                                                                            "comment-" +
                                                                            ticket.id
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "label",
                                                                          [
                                                                            _vm._v(
                                                                              "Please enter comment"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "a",
                                                                      {
                                                                        attrs: {
                                                                          href:
                                                                            "javascript:void(0)"
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.submitUserComment(
                                                                              ticket
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Waiting for Rep."
                                                                        )
                                                                      ]
                                                                    )
                                                                  ],
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "not-attended-ticket"
                                                                },
                                                                [
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "checkbox-inline checkbox-bootstrap checkbox-lg"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "input",
                                                                        {
                                                                          attrs: {
                                                                            id:
                                                                              "not-attended-" +
                                                                              ticket.id,
                                                                            type:
                                                                              "checkbox"
                                                                          },
                                                                          on: {
                                                                            change: function(
                                                                              $event
                                                                            ) {
                                                                              return _vm.moveTicketToNotAttendedCustomer(
                                                                                $event,
                                                                                ticket.id,
                                                                                ticket.ticket_number
                                                                              )
                                                                            }
                                                                          }
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "checkbox-placeholder"
                                                                        }
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "not-attended-ticket-label"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Not Attended"
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            2
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "form-group cards-right"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "checkbox-inline checkbox-bootstrap checkbox-lg"
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    attrs: {
                                                                      id:
                                                                        ticket.id,
                                                                      type:
                                                                        "checkbox"
                                                                    },
                                                                    on: {
                                                                      change: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.closeTicket(
                                                                          $event,
                                                                          ticket.id,
                                                                          ticket.ticket_number
                                                                        )
                                                                      }
                                                                    }
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _c("span", {
                                                                    staticClass:
                                                                      "checkbox-placeholder"
                                                                  })
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  : _vm._e()
                                              ],
                                              2
                                            )
                                          ]
                                        : _vm._e()
                                    ]
                                  })
                                ]
                              : [
                                  _c(
                                    "div",
                                    { staticClass: "page-name col-md-12" },
                                    [
                                      _vm._v(
                                        "\n                    No Numbers Available.\n                  "
                                      )
                                    ]
                                  )
                                ]
                          ],
                          2
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-tab",
                      {
                        attrs: {
                          title: "Closed Customer Numbers",
                          id: "Close Tickets"
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "grid-container" },
                          [
                            _vm.ticketsClosedFound == true
                              ? [
                                  _vm._l(_vm.ticketsClosed, function(
                                    ticket,
                                    key
                                  ) {
                                    return [
                                      ticket.ticket_closed_at != null
                                        ? [
                                            _c(
                                              "div",
                                              {
                                                key: key,
                                                staticClass: "cards-block"
                                              },
                                              [
                                                ticket.is_printed == 0
                                                  ? [
                                                      _c(
                                                        "b-card",
                                                        {
                                                          staticClass:
                                                            "mb-2 custom-card-body ticket-unprinted",
                                                          attrs: {
                                                            tag: "article"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "cards-left"
                                                            },
                                                            [
                                                              _c(
                                                                "p",
                                                                {
                                                                  staticClass:
                                                                    "card-text cards-page-name"
                                                                },
                                                                [
                                                                  _c("strong", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        ticket.ticket_number
                                                                      )
                                                                    )
                                                                  ])
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("timeago", {
                                                                attrs: {
                                                                  datetime:
                                                                    ticket.ticket_closed_date_time,
                                                                  "auto-update": 60,
                                                                  locale:
                                                                    "en-US"
                                                                }
                                                              })
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "form-group cards-right"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "checkbox-inline checkbox-bootstrap checkbox-lg"
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    attrs: {
                                                                      id:
                                                                        ticket.id,
                                                                      type:
                                                                        "checkbox"
                                                                    },
                                                                    on: {
                                                                      change: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.reopenTicket(
                                                                          $event,
                                                                          ticket.id,
                                                                          ticket.ticket_number
                                                                        )
                                                                      }
                                                                    }
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _c("span", {
                                                                    staticClass:
                                                                      "checkbox-placeholder"
                                                                  })
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                ticket.is_printed == 1
                                                  ? [
                                                      _c(
                                                        "b-card",
                                                        {
                                                          staticClass:
                                                            "mb-2 custom-card-body",
                                                          attrs: {
                                                            tag: "article"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "cards-left"
                                                            },
                                                            [
                                                              _c(
                                                                "p",
                                                                {
                                                                  staticClass:
                                                                    "card-text cards-page-name"
                                                                },
                                                                [
                                                                  _c("strong", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        ticket.ticket_number
                                                                      )
                                                                    )
                                                                  ])
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("timeago", {
                                                                attrs: {
                                                                  datetime:
                                                                    ticket.ticket_closed_date_time,
                                                                  "auto-update": 60,
                                                                  locale:
                                                                    "en-US"
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              ticket.is_user_comment !=
                                                              0
                                                                ? [
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          ticket.user_comment
                                                                        )
                                                                      )
                                                                    ])
                                                                  ]
                                                                : _vm._e()
                                                            ],
                                                            2
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "form-group cards-right"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "checkbox-inline checkbox-bootstrap checkbox-lg"
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    attrs: {
                                                                      id:
                                                                        ticket.id,
                                                                      type:
                                                                        "checkbox"
                                                                    },
                                                                    on: {
                                                                      change: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.reopenTicket(
                                                                          $event,
                                                                          ticket.id,
                                                                          ticket.ticket_number
                                                                        )
                                                                      }
                                                                    }
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _c("span", {
                                                                    staticClass:
                                                                      "checkbox-placeholder"
                                                                  })
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  : _vm._e()
                                              ],
                                              2
                                            )
                                          ]
                                        : _vm._e()
                                    ]
                                  })
                                ]
                              : [
                                  _c(
                                    "div",
                                    { staticClass: "page-name col-md-12" },
                                    [
                                      _vm._v(
                                        "\n                    No Numbers Available.\n                  "
                                      )
                                    ]
                                  )
                                ]
                          ],
                          2
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-tab",
                      {
                        attrs: {
                          title: "Customer Not Attended",
                          id: "customerNotAttended"
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "grid-container" },
                          [
                            _vm.customerNotAttendedFound == true
                              ? [
                                  _vm._l(_vm.customerNotAttended, function(
                                    ticket,
                                    key
                                  ) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          key: key,
                                          staticClass: "cards-block"
                                        },
                                        [
                                          ticket.is_printed == 0
                                            ? [
                                                _c(
                                                  "b-card",
                                                  {
                                                    staticClass:
                                                      "mb-2 custom-card-body ticket-unprinted",
                                                    attrs: { tag: "article" }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "cards-left"
                                                      },
                                                      [
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "card-text cards-page-name"
                                                          },
                                                          [
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  ticket.ticket_number
                                                                )
                                                              )
                                                            ])
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("timeago", {
                                                          attrs: {
                                                            datetime:
                                                              ticket.ticket_generated_date_time,
                                                            "auto-update": 60,
                                                            locale: "en-US"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "form-group cards-right"
                                                      },
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "checkbox-inline checkbox-bootstrap checkbox-lg"
                                                          },
                                                          [
                                                            _c("input", {
                                                              attrs: {
                                                                id: ticket.id,
                                                                type: "checkbox"
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.reopenTicket(
                                                                    $event,
                                                                    ticket.id,
                                                                    ticket.ticket_number
                                                                  )
                                                                }
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c("span", {
                                                              staticClass:
                                                                "checkbox-placeholder"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          ticket.is_printed == 1
                                            ? [
                                                _c(
                                                  "b-card",
                                                  {
                                                    staticClass:
                                                      "mb-2 custom-card-body",
                                                    attrs: { tag: "article" }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "cards-left"
                                                      },
                                                      [
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "card-text cards-page-name"
                                                          },
                                                          [
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  ticket.ticket_number
                                                                )
                                                              )
                                                            ])
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("timeago", {
                                                          attrs: {
                                                            datetime:
                                                              ticket.ticket_generated_date_time,
                                                            "auto-update": 60,
                                                            locale: "en-US"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        ticket.is_user_comment !=
                                                        0
                                                          ? [
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    ticket.user_comment
                                                                  )
                                                                )
                                                              ])
                                                            ]
                                                          : _vm._e()
                                                      ],
                                                      2
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "form-group cards-right"
                                                      },
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "checkbox-inline checkbox-bootstrap checkbox-lg"
                                                          },
                                                          [
                                                            _c("input", {
                                                              attrs: {
                                                                id: ticket.id,
                                                                type: "checkbox"
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.reopenTicket(
                                                                    $event,
                                                                    ticket.id,
                                                                    ticket.ticket_number
                                                                  )
                                                                }
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c("span", {
                                                              staticClass:
                                                                "checkbox-placeholder"
                                                            })
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "not-attended-label"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Not Attended"
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    ]
                                  })
                                ]
                              : [
                                  _c(
                                    "div",
                                    { staticClass: "page-name col-md-12" },
                                    [
                                      _vm._v(
                                        "\n                    No Numbers Available.\n                  "
                                      )
                                    ]
                                  )
                                ]
                          ],
                          2
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-tab",
                      { attrs: { title: "Not in Queue", id: "openTickets" } },
                      [
                        _c(
                          "div",
                          { staticClass: "grid-container" },
                          [
                            _vm.customerNotInQueueFound == true
                              ? [
                                  _vm._l(_vm.customerNotInQueue, function(
                                    ticket,
                                    key
                                  ) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          key: key,
                                          staticClass: "cards-block"
                                        },
                                        [
                                          ticket.customerNotInQueue == "true"
                                            ? [
                                                _c(
                                                  "b-card",
                                                  {
                                                    staticClass:
                                                      "mb-2 custom-card-body",
                                                    attrs: { tag: "article" }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "cards-left"
                                                      },
                                                      [
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "card-text cards-page-name"
                                                          },
                                                          [
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  ticket.ticket_no
                                                                )
                                                              )
                                                            ])
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "form-group cards-right"
                                                      },
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "checkbox-inline checkbox-bootstrap checkbox-lg"
                                                          },
                                                          [
                                                            _c("input", {
                                                              attrs: {
                                                                id:
                                                                  "ticket-" +
                                                                  key,
                                                                type: "checkbox"
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.closeTicket(
                                                                    $event,
                                                                    "",
                                                                    ticket.ticket_no,
                                                                    (_vm.flag =
                                                                      "customerNotInQueue")
                                                                  )
                                                                }
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c("span", {
                                                              staticClass:
                                                                "checkbox-placeholder"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          ticket.customerNotInQueue == "false"
                                            ? [
                                                _c(
                                                  "b-card",
                                                  {
                                                    staticClass:
                                                      "mb-2 custom-card-body ticket-unprinted",
                                                    attrs: { tag: "article" }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "cards-left"
                                                      },
                                                      [
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "card-text cards-page-name"
                                                          },
                                                          [
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  ticket.ticket_no
                                                                )
                                                              )
                                                            ])
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "form-group cards-right"
                                                      },
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "checkbox-inline checkbox-bootstrap checkbox-lg"
                                                          },
                                                          [
                                                            _c("span", {
                                                              staticClass:
                                                                "checkbox-placeholder"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    ]
                                  })
                                ]
                              : [
                                  _c(
                                    "div",
                                    { staticClass: "page-name col-md-12" },
                                    [
                                      _vm._v(
                                        "\n                    No Numbers Available.\n                  "
                                      )
                                    ]
                                  )
                                ]
                          ],
                          2
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("app-footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e64031b8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e64031b8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CloseTicket.vue
// module id = null
// module chunks = 